import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const autoconsumo = {
	state: {

	},
	getters: {

	},
	actions: {
		sendCalculoAutoconsumo: ({ commit }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/solar/save', data).then(result => {
					if (result.data.status) {
						resolve(result.data)
					}
				}).catch(error => {
					reject(false);
				});

			});
		}
	},
	mutations: {

	}
}

export default autoconsumo;



// WEBPACK FOOTER //
// ./src/store/autoconsumo.js